import api from './api';

export async function fetchDashboardContentData() {
  const response = await api.get('/get-dashboard-content-data');
  return response?.data?.dataset?.data || {};
}
